import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function GAListener() {
  const location = useLocation();
  const navigationType = useNavigationType(); // PUSH, POP, or REPLACE

  useEffect(() => {
    // Only send GA events if:
    // 1. Consent was granted
    // 2. Conditions are met (HTTPS and correct hostname)
    // 3. gtag is available
    const consent = localStorage.getItem('ga_consent');
    const isProduction = process.env.REACT_APP_ENV === 'production';
    const isSecure = window.location.protocol === 'https:';
    const isCorrectHost = window.location.hostname === 'portal.xtract2ai.com';
    const hasConsent = consent === 'granted';
    const hasGtag = typeof window.gtag === 'function';

    if (isProduction && isSecure && isCorrectHost && hasConsent && hasGtag) {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location, navigationType]);

  return null;
}
